import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Category } from "@/schema/free-assessment/Category";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface QuestionProps {
  categoryIndex: number;
  subCategoryIndex: number;
  questionIndex: number;
  control: Control<{ categories: Category[] }>;
}

function Question({
  categoryIndex,
  subCategoryIndex,
  questionIndex,
  control,
}: QuestionProps) {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={`categories.${categoryIndex}.sub_categories.${subCategoryIndex}.questions.${questionIndex}`}
      rules={{
        required: true,
        validate: (question) => {
          if (!question.answer) {
            return t("please_select_an_answer");
          }
        },
      }}
      render={({
        field: { onChange, value: question, ref },
        fieldState: { error },
      }) => (
        <div className="pb-6 pt-5 sm:px-5">
          <div className="font-medium whitespace-pre-wrap">{question.content}</div>
          <RadioGroup
            ref={ref}
            className="mt-5 inline-flex flex-col gap-3 sm:flex-row sm:gap-12"
            value={question.answer ? question.answer.toString() : ""}
            onValueChange={(value) => {
              onChange({
                ...question,
                answer: parseInt(value),
              });
            }}
          >
            <label
              htmlFor={`${question.id} 0`}
              className="inline-flex cursor-pointer items-center gap-2"
            >
              <RadioGroupItem value="1" id={`${question.id} 0`} />
              <span>{t("yes")}</span>
            </label>
            <label
              htmlFor={`${question.id} 1`}
              className="inline-flex cursor-pointer items-center gap-2"
            >
              <RadioGroupItem value="2" id={`${question.id} 1`} />
              <span>{t("no")}</span>
            </label>
            <label
              htmlFor={`${question.id} 2`}
              className="inline-flex cursor-pointer items-center gap-2"
            >
              <RadioGroupItem value="3" id={`${question.id} 2`} />
              <span>{t("not-applicable")}</span>
            </label>
          </RadioGroup>
          <div className="text-red-500">{error?.message}</div>
        </div>
      )}
    />
  );
}

export default Question;
